import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4a1d6f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-content" }
const _hoisted_2 = { class: "langs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flag" }
const _hoisted_5 = { class: "name" }

import { PropType, ref, Ref, computed } from 'vue'
import { useStoreAuth } from '@/store/auth'
import { DigUiPopup } from '@digithia/ui'
import { countries } from './BaseLocale'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLocalePopup',
  props: {
  langs: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  emits: ['update'],
  setup(__props, { emit: emits }) {

const props = __props

const storeAuth = useStoreAuth()




const popupLang: Ref<DigUiPopup | null> = ref(null)

const currentCountries = computed(() => {
  return countries.filter((country) => props.langs.includes(country.lang))
})

const close = () => {
  popupLang.value?.close()
}

const changeLocale = (lang: string) => {
  storeAuth.changeLang(lang)
  emits('update', lang)
  close()
}

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_icon = _resolveComponent("dig-ui-icon")!
  const _component_dig_ui_title = _resolveComponent("dig-ui-title")!

  return (_openBlock(), _createBlock(_unref(DigUiPopup), {
    id: "popup-lang",
    ref_key: "popupLang",
    ref: popupLang
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_dig_ui_icon, {
          class: "close-popup",
          type: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
        }),
        _createVNode(_component_dig_ui_title, { class: "title-3 center" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('chooseLang')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentCountries), (country) => {
            return (_openBlock(), _createElementBlock("div", {
              key: country.lang,
              class: "lang",
              onClick: ($event: any) => (changeLocale(country.lang))
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(country.flag), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(country.name), 1)
            ], 8, _hoisted_3))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})